import { createAuthClient } from "better-auth/client";
import { usernameClient } from "better-auth/client/plugins";
import { baseUrl, setToken, token } from "./api.ts";

/**
 * The auth calls `api()` cannot make by hand: username sign-in, sign-out and
 * the passkey endpoint calls. Everything else in this app reads and writes
 * through `api()` in `./api.ts` — the one seam that holds the token. A
 * passkey ceremony itself runs through the native passkey plugin now, on
 * every platform (`#268`) — `apps/staff/src/lib/passkey.ts` reaches the two
 * ceremony endpoints through this client's own `$fetch`, and hands what the
 * plugin returns back to them for verification.
 *
 * Bearer, not a cookie, on the same terms as `apps/pos`: the server's
 * `bearer()` plugin returns the session token in the `set-auth-token` header
 * on a successful call, and this is the documented way a bearer client reads
 * it back — `fetchOptions.auth` sends whatever `token()` holds, and
 * `onSuccess` is what carries a freshly issued one into `setToken`.
 */
export const authClient = createAuthClient({
  baseURL: baseUrl(),
  basePath: "/api/auth",
  plugins: [usernameClient()],
  fetchOptions: {
    auth: { type: "Bearer", token: () => token() ?? "" },
    onSuccess: (context) => {
      const issued = context.response.headers.get("set-auth-token");
      if (issued) setToken(issued);
    },
  },
});
